export default "__VITE_ASSET__505dc2ca__"